<template>
    <button class="icon-filter" :class="{ 'active': isActive }" @click="toggleFilter" :aria-pressed="isPressed">
        <span v-html="data.SvgContent"></span>
        <div class="icon-text" v-text="data.Text"></div>
    </button>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    methods: {
        toggleFilter(e) {
            this.$store.commit('filters/toggleActiveFilters', this.$props.data.Key);
            this.$store.dispatch('filterAttractions');
        },
    },
    computed: {
        isActive(){
            return this.$store.state.filters.activeFilters.includes(this.$props.data.Key);
        },
        isPressed() {
            return this.isActive.toString();
        }
    },
}
</script>
